// Generic empty-state component for list / grid / dashboard views.
// Drop into any container with `extends: 'EmptyState'` and override
// the `icon`, `title`, `hint`, `action` props as needed.
//
// Pattern:
//   MyEmptyState: {
//     extends: 'EmptyState',
//     icon: 'people',
//     title: 'No team members yet',
//     hint: 'Invite teammates to start collaborating.',
//     action: { text: 'Invite member', onClick: (e, el, s) => ... }
//   }
//
// All strings render through `polyglot` translation when wrapped at the
// call site — empty-state copy is user-facing.

export const EmptyState = {
  flow: 'y',
  align: 'center center',
  gap: 'A',
  padding: 'C A',
  width: '100%',
  textAlign: 'center',

  // Default props — consumers override.
  icon: null,
  title: '',
  hint: '',
  action: null,

  // Decorative icon — falls back to nothing if no icon prop.
  IconWrap: {
    if: (el) => !!el.parent?.icon,
    flow: 'y',
    align: 'center center',
    width: 'C',
    height: 'C',
    round: '50%',
    background: 'overlay',
    color: 'caption',
    Icon: {
      icon: (el) => el.parent.parent.icon,
      boxSize: 'A1'
    }
  },

  Title: {
    tag: 'h3',
    fontSize: 'A1',
    fontWeight: '700',
    color: 'title',
    margin: '0',
    text: (el) => el.parent.title || ''
  },

  Hint: {
    if: (el) => !!el.parent?.hint,
    tag: 'p',
    fontSize: 'Z2',
    color: 'caption',
    margin: '0',
    maxWidth: 'J',
    text: (el) => el.parent.hint || ''
  },

  ActionBtn: {
    if: (el) => !!el.parent?.action,
    tag: 'button',
    type: 'button',
    padding: 'V A',
    round: 'Z',
    background: 'blue',
    color: 'white',
    fontSize: 'Z2',
    fontWeight: '600',
    border: 'none',
    cursor: 'pointer',
    marginTop: 'V',
    text: (el) => el.parent?.action?.text || '',
    onClick: (e, el, s) => {
      const action = el.parent?.action
      if (typeof action?.onClick === 'function') action.onClick(e, el, s)
    }
  }
}
